/* Special Delivery -- Warm Theme JS */
(function () {
  'use strict';

  /* -- Smooth scroll for anchor links ------------------- */
  function initSmoothScroll() {
    document.querySelectorAll('a[href^="#"]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var id = a.getAttribute('href').slice(1);
        var el = document.getElementById(id);
        if (!el) return;
        e.preventDefault();
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  /* -- ATC hover ----------------------------------------- */
  function initAtcHover() {
    var btn = document.getElementById('wt-atc-btn');
    if (!btn) return;
    btn.addEventListener('mouseenter', function () { btn.style.opacity = '.9'; });
    btn.addEventListener('mouseleave', function () { btn.style.opacity = '1'; });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initSmoothScroll();
    initAtcHover();
  });
})();
